export default "__VITE_ASSET__8w1u8a6k__"